import axios from "axios";
import { GetAllFiltersPersonalManagmentDTO, GetAllPersonalManagementDTO, PersonalManagementDTO, PersonalManagementUpdateDTO } from "./dto";
import { PersonalManagementService } from "./service";
import { keycloak } from "../../../lib/keycloak";
import { downloadFileFromResponse } from "../../../utils/download";

export class PersonalManagementServiceImpl implements PersonalManagementService {

    public GetAllPersonalManagementResources(filters: GetAllFiltersPersonalManagmentDTO): Promise<GetAllPersonalManagementDTO> {
        return axios.get("/api/personal-management", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page,
                norm: filters.norm,
                order: filters.order,
                region: filters.region,
                surname: filters.surname != '' ? filters.surname : undefined,
                function: filters.function,
                sort: filters.sort,
                active: filters.active
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public DownloadSPrev3(id: string): Promise<void> {
        return axios.get(`/api/download/sp-rev-03/${id}`, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            },
            responseType: 'text',
        }).then((response) => {
            downloadFileFromResponse(response.data, 'CSX SP rev3 .docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
        }).catch((error) => {
            console.error('Errore durante il download del file:', error);
        });
    }

    public DownloadCV(id: string): Promise<void> {
        return axios.get(`/api/download/curriculum/${id}`, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            },
            responseType: 'text',
        }).then((response) => {
            downloadFileFromResponse(response.data, 'document.odt', 'application/vnd.oasis.opendocument.text');
        }).catch((error) => {
            console.error('Errore durante il download del file:', error);
        });
    }

    public GetByIdPersonalManagementResources(id: string): Promise<PersonalManagementDTO> {
        return axios.get("/api/personal-management/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public CreatePersonalManagementResource(): Promise<string> {
        return axios.post("/api/personal-management",
            {},
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdatePersonalManagementResource(data: PersonalManagementUpdateDTO, id: string): Promise<void> {
        return axios.put("/api/personal-management/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}